import { useReveal } from "@/hooks/useReveal";

const VARIANTS = {
  up: "translate-y-8",
  down: "-translate-y-8",
  left: "translate-x-8",
  right: "-translate-x-8",
  fade: "",
};

export const Reveal = ({
  children,
  delay = 0,
  duration = 800,
  direction = "up",
  className = "",
  as: Tag = "div",
}) => {
  const [ref, visible] = useReveal();
  const translate = VARIANTS[direction] || VARIANTS.up;
  return (
    <Tag
      ref={ref}
      className={`${className} ${visible ? "opacity-100 translate-y-0 translate-x-0" : `opacity-0 ${translate}`}`}
      style={{
        transitionProperty: "opacity, transform",
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        transitionDelay: `${delay}ms`,
        willChange: "opacity, transform",
      }}
    >
      {children}
    </Tag>
  );
};
